import type { SortDirection } from '@tanstack/table-core';
import clsx from 'clsx';
import { type PropsWithChildren } from 'react';
import { useIntl } from 'react-intl';

import {
  ArrowSmallDownIcon,
  SorterSmallDoubleIcon,
} from '@dynatrace/strato-icons';

import { sortingArrowCSS } from './Sorting.sty.js';

/**
 * Renders button within the column header to trigger sorting directly on header click.
 * @internal
 */
export const SortingArrowIndicators = (
  props: PropsWithChildren<{
    isSorted?: false | SortDirection;
    rowDensity: 'default' | 'condensed' | 'comfortable';
  }>,
) => {
  const { isSorted, rowDensity } = props;

  const intl = useIntl();

  if (isSorted !== false) {
    return (
      <ArrowSmallDownIcon
        data-sorticon
        style={{ display: 'inline' }}
        className={clsx(
          sortingArrowCSS({ arrowUp: isSorted === 'asc', rowDensity }),
        )}
      />
    );
  }

  return (
    <SorterSmallDoubleIcon
      data-sorticon
      aria-label={intl.formatMessage({
        defaultMessage: 'Icon indicating that the column is sortable',
        id: 'Ah9w1glbeyevy7N+',
        description:
          'Aria-label for sortable columns that are not yet sorted in any direction.',
      })}
      className={sortingArrowCSS({ rowDensity })}
    />
  );
};
